export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8118.8e049bf7.jpg";